import React from 'react'
import { Loader, TextField } from '@cicero/ui'
import { TableLayout } from 'views/layouts'
import { PageSchema } from 'models'
import { IDashboardWidgetElement, IEditorWidget, IEditorWidgetConfigSchema } from '../EditorService'
import { IPageFilter } from 'models/filters'
import { PageFilters } from 'forms'

export const TableViewWidget = ({ config }: { config: ITableViewWidgetConfig }) => {
  const [isLoading, results] = PageSchema.HOOKS.usePageFilters(config.filters || [])
  return <>
    <TableLayout pages={results} />
    { isLoading ? <Loader /> : null }
  </>
}

export const FilterWidgetConfig: IEditorWidgetConfigSchema<IPageFilter[]> = {
  key: 'filters',
  label: 'Filters',
  defaultValue: [],
  validate() { return null },
  renderForm(value: IPageFilter[], setValue) {
    return <PageFilters
      name="filters"
      value={value}
      onChange={(ev) => setValue(ev.target.value)}
    />
  },
}

const FilterTemplateIdsConfig: IEditorWidgetConfigSchema<string[]> = {
  key: 'filter_template_ids',
  label: 'Templates',
  defaultValue: [],
  validate() { return null },
  renderForm(value, setValue) {
    return <TextField value={value.join(',')} onChange={(e) => setValue(e.target.value.split(','))} />
  },
}

export const tableViewerWidget: IEditorWidget = {
  id: 'tableviewer',
  name: 'Table Viewer',
  description: 'Show pages in a query in a table',
  image: require('./img/table.png'),
  renderer: (leaf) => <TableViewWidget config={leaf}/>,
  configSchema: [
    // FilterWidgetConfig,
    FilterTemplateIdsConfig,
  ],
}

export interface ITableViewWidgetConfig extends IDashboardWidgetElement {
  filters?: IPageFilter[]
}
